export const NO_SPECIAL_WARNING = "no_warning_required";
export const MAXIMUM_LIQUID_TEMPERATURE = "max_liquid_temperature";
export const OTHER_WARNING = "other";

export {
  FALLBACK_USE_RESTRICTION_OPTIONS as APPROVED_USE_RESTRICTION_OPTIONS,
  FALLBACK_MINIMUM_USER_AGE_OPTIONS as MINIMUM_USER_AGE_OPTIONS,
} from "./gpsrSelectOptions";

const CARE_SYMBOL_CONFLICT_PAIRS = [
  ["machine_wash", "do_not_wash"],
  ["hand_wash", "do_not_wash"],
  ["tumble_dry", "do_not_tumble_dry"],
  ["iron_at_low_temperature", "do_not_iron"],
  ["iron_at_medium_temperature", "do_not_iron"],
  ["iron_at_high_temperature", "do_not_iron"],
  ["professional_dry_clean", "do_not_dry_clean"],
];

const getCareSymbolConflicts = (value) => {
  const conflicts = new Set();
  CARE_SYMBOL_CONFLICT_PAIRS.forEach(([a, b]) => {
    if (a === value) conflicts.add(b);
    if (b === value) conflicts.add(a);
  });
  return conflicts;
};

export const buildInitialSafety = () => ({
  safetyInformation: "",
  approvedUseRestrictions: [],
  maximumLiquidTemperature: "",
  minimumUserAge: "",
  careSymbols: [],
  additionalCareInstructions: "",
  other: "",
});

export const normalizeApprovedUseRestrictions = (selected = []) => {
  const unique = [];
  const seen = new Set();
  (Array.isArray(selected) ? selected : []).forEach((item) => {
    const value = String(item ?? "").trim();
    if (!value || seen.has(value)) return;
    seen.add(value);
    unique.push(value);
  });

  if (unique.includes(NO_SPECIAL_WARNING) && unique.length > 1) {
    if (unique[unique.length - 1] === NO_SPECIAL_WARNING) {
      return [NO_SPECIAL_WARNING];
    }
    return unique.filter((value) => value !== NO_SPECIAL_WARNING);
  }

  return unique;
};

export const normalizeCareSymbols = (
  nextSelected = [],
  previousSelected = []
) => {
  const unique = [];
  const seen = new Set();
  (Array.isArray(nextSelected) ? nextSelected : []).forEach((item) => {
    const value = String(item ?? "").trim();
    if (!value || seen.has(value)) return;
    seen.add(value);
    unique.push(value);
  });

  const previous = new Set(
    (Array.isArray(previousSelected) ? previousSelected : [])
      .map((item) => String(item ?? "").trim())
      .filter(Boolean)
  );
  const added = unique.filter((value) => !previous.has(value));
  if (added.length === 0) return unique;

  let result = unique;
  added.forEach((value) => {
    const conflicts = getCareSymbolConflicts(value);
    if (conflicts.size === 0) return;
    result = result.filter(
      (item) => item === value || !conflicts.has(item)
    );
  });
  return result;
};

export const hasRestriction = (restrictions, value) =>
  (Array.isArray(restrictions) ? restrictions : []).some(
    (item) => String(item) === String(value)
  );

export const validateSafety = (safety = {}) => {
  const errors = {
    maximumLiquidTemperature: "",
    other: "",
  };

  const restrictions = Array.isArray(safety.approvedUseRestrictions)
    ? safety.approvedUseRestrictions
    : [];

  if (hasRestriction(restrictions, MAXIMUM_LIQUID_TEMPERATURE)) {
    const raw = String(safety.maximumLiquidTemperature ?? "").trim();
    const num = Number(raw.replace(",", "."));
    if (!raw || !Number.isFinite(num) || num <= 0) {
      errors.maximumLiquidTemperature =
        "Enter a temperature greater than 0";
    }
  }

  if (hasRestriction(restrictions, OTHER_WARNING)) {
    if (!String(safety.other ?? "").trim()) {
      errors.other = "Enter a custom warning";
    }
  }

  return {
    errors,
    isValid: !errors.maximumLiquidTemperature && !errors.other,
  };
};
